import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import * as _ from 'underscore'
import {HOME_PAGE_URL, VERIFY_PAGE_URL, NON_EDITABLE_STATUS} from '../../../constants';

import UserInfoUI from '../../../stories/components/Onboarding/UserInfo/UserInfoUI';
import {setter, getter, removeItem, hasItem} from '../../../../../../common/client-side-storage/src/client-side-storage.web';
import * as actions from '../../../store/actions/index';
import {userDataSelector, errorSelector, tokenSelector, nextLoader, statusSelector, directLandingSelector} from '../../../store/selectors';

const UserInfo = props => {
  const history = useHistory();
  const location = useLocation()
  const dispatch = useDispatch();

  const userInfo = useSelector(userDataSelector);
  const token = useSelector(tokenSelector);
  const error = useSelector(errorSelector);
  const status = useSelector(statusSelector);
  const setLoader = useSelector(nextLoader);
  const directLanding = useSelector(directLandingSelector);

  const successCallback = (t, s) => {
    if (s !== 'active') {
      // remove from the local storage when the registration of the user is successful, step {1}
      setter("token", `${t}`);
      history.replace(`${HOME_PAGE_URL}`);
      history.push(`${VERIFY_PAGE_URL}`);
    }
  }
  const getQuery = () => {
    const searchQuery = new URLSearchParams(location.search);
    let queryParamsObject = {}

    /*
    ref and cpm are 2 separate use cases, anyone is present, send all the query params to the api call
    */

  if (hasItem('ref')) {
    if(searchQuery.has('ref')){
      removeItem('ref');
      setter('ref', searchQuery.get('ref'))
    }
    queryParamsObject['ref'] = getter('ref')
  }else if (searchQuery.has('ref')) {

    // dict of all query params .. since location.query is deprecated
    queryParamsObject =  {...queryParamsObject, ...(Object.fromEntries(searchQuery))}

    // just another step in case ref related query params are sent
    //to persist if ref is present on landing and is not present in local storage or present/ and updatingg
    if (searchQuery.has('ref')) {
      // localstorage access after window checks
      setter('ref', searchQuery.get('ref'))
      }
    // case to fetch from localstorage, if the user lands on the home page for the second time directly
    }

    if (searchQuery.has('cmp')) {

        // dict of all query params .. since location.query is deprecated
        queryParamsObject =  {...(Object.fromEntries(searchQuery)), cmp:getter('cmp'),...queryParamsObject}

        // case to fetch from localstorage, if the user lands on the home page for the second time directly
        }else if (hasItem('cmp')) {
          queryParamsObject['cmp'] = getter('cmp')
        }

    return queryParamsObject
  }

  const setUserInfo = data => {
    if (NON_EDITABLE_STATUS.indexOf(status) !== -1) {
      successCallback(token ? token : '', status);
      return;
    }
    if(data.title === userInfo.title && data.full_name === userInfo.fullName && data.email === userInfo.email && data.mobile === userInfo.mobile && data.country_code === userInfo.countryCode){
      successCallback(token ? token : '', status);
      return;
    }else{
      /*
      Mainly to handle the case where the user lands on the home page from a link from a business agent

      References for tagging agenet's signup to business agents. Usually we get it when user lands from the shared referal
      links.
          >>Two types :
      Ref or anything related to that - should be persisted across window closes
      cpm, and anything related to that - should just be forwarded
      */

      let fd = new FormData();
      let additionalQueryData = getQuery()

      // spread both the values -- original form data and the new additional fields which should be sent to register api
      // combine the objets
      let combinedFormData = {...data , ...additionalQueryData}
      for (let key in combinedFormData) {
        fd.append(key, combinedFormData[key]);
      }

      dispatch(actions.registerNewUser(data, fd, successCallback));
    }

  };

  return <UserInfoUI userInfo={userInfo} onSubmitUserInfo={setUserInfo} apiError={error} status={status} setLoader={setLoader} directLanding={directLanding} />;
};

export default UserInfo;
